// extracted by mini-css-extract-plugin
export default {"badge":"Badge-module_badge__nyIKo","sm":"Badge-module_sm__SwryD"};